export default __webpack_public_path__ + "static/media/HTBRIDGE_icon.93c48dc0.png";